import React from "react"
import comingSoon from "assets/images/coming-soon.png"
import { Skeleton } from "@walmart-web/livingdesign-components"
import { FormattedMessage } from "react-intl"
import "./index.scss"

interface ComingSoonProps {
	isLoading: boolean
}

const ComingSoon: React.FC<ComingSoonProps> = ({ isLoading }) => {
	return isLoading ? (
		<React.Fragment>
			<Skeleton role="progressbar" UNSAFE_className="title-skeleton" />
			<Skeleton role="progressbar" />
			<Skeleton role="progressbar" UNSAFE_className="chart-skeleton" />
		</React.Fragment>
	) : (
		<React.Fragment>
			<div className="coming-soon">
				<img alt="coming-soon" className="image" src={comingSoon} />
				<div className="text">
					<div className="title">
						<FormattedMessage id="phronesis.customerbehavior.application.customerProfiling.segmentationSummary.comingSoon.title" />
					</div>
					<div className="subtitle">
						<FormattedMessage id="phronesis.customerbehavior.application.customerProfiling.segmentationSummary.comingSoon.description" />
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}

export default ComingSoon
